import React from 'react';
import { styled } from '@slicknode/stylemapper';
import { twMerge } from 'tailwind-merge';

const StyledChipButton = styled(
  'button',
  'flex h-full w-full rounded-full items-center gap-2 whitespace-nowrap',
  'justify-center px-3 font-base text-base-m font-normal capitalize',
  {
    variants: {
      disabled: {
        true: 'cursor-not-allowed opacity-30',
        false: 'cursor-pointer',
      },
      selected: {
        true: 'bg-base800 text-white',
        false: 'bg-base100 text-black',
      },
    },
    compoundVariants: [
      {
        disabled: false,
        selected: true,
        className: 'hover:bg-black',
      },
      {
        disabled: false,
        selected: false,
        className: 'hover:bg-base300',
      },
    ],
    forwardProps: ['disabled'],
  },
);

export const Chip = ({
  text,
  icon,
  isSelected,
  disabled,
  onClick,
  onMouseOver,
  className = '',
}: {
  className?: string;
  text: string;
  icon?: React.ReactNode;
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
  onMouseOver?: () => void;
}) => {
  return (
    <div className={twMerge('h-8 border border-solid border-transparent', className)}>
      <StyledChipButton
        selected={isSelected}
        aria-label={text}
        aria-disabled={disabled}
        onClick={onClick}
        disabled={disabled}
        onMouseOver={onMouseOver}
      >
        {icon && <div className="flex h-4 w-4 items-center">{icon}</div>}
        <p>{text}</p>
      </StyledChipButton>
    </div>
  );
};
